/** @format */

import {useMemo} from 'react';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AppsIcon from '@mui/icons-material/Apps';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import {Box, List, Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {Trans} from 'react-i18next';

import {AssignmentOutlined} from '@mui/icons-material';

import {useIsSpecialist} from 'helpers/hooks/useIsSpecialist';

import RowNew from './RowNew';

const useStyles = makeStyles(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    borderRadius: '50%',
    height: theme.spacing(18),
    overflow: 'hidden',
    width: theme.spacing(18),
  },
  avatarIcon: {
    backgroundColor: '#FFF',
    fontSize: 118,
  },
  list: {
    width: theme.spacing(72),
  },
  listItem: {
    backgroundColor: theme.palette.action.disabledBackground,
    borderRadius: 8,
    color: 'white',
    height: 56,
    marginBottom: theme.spacing(4),
  },
  logout: {
    cursor: 'pointer',
  },
  logoutIcon: {
    marginRight: -5,
  },

  headerTitle: {
    fontSize: '28px',
    fontWeight: 700,
  },
  listNew: {
    width: '100%',
  },
}));

const Entry = () => {
  const classes = useStyles();

  // Управление доступами доступно только владельцу, не специалисту (sub-аккаунту).
  // Fail closed: пока роль не подтверждена (loading) или запрос упал (error) — пункт скрыт.
  const {loading, error, isSpecialist} = useIsSpecialist();
  const canManageAccess = !loading && !error && !isSpecialist;

  const settingsLinksList = useMemo(
    () => [
      {
        href: '/home/settings/profile',
        mixpanelEventName: 'open_profile_page',
        icon: <AccountCircleOutlinedIcon />,
        title: <Trans>Настройки аккаунта</Trans>,
      },
      {
        href: '/home/settings/tariffs',
        mixpanelEventName: 'open_tariffs_page',
        icon: <AssignmentOutlined />,
        title: <Trans>Настройки тарифа</Trans>,
      },
      {
        href: '/home/settings/connect',
        mixpanelEventName: 'open_connect_page',
        icon: <AppsIcon />,
        title: <Trans>Управление проектами</Trans>,
      },
      ...(canManageAccess
        ? [
            {
              href: '/home/settings/connected_users',
              mixpanelEventName: 'open_connected_users_page',
              icon: <SecurityOutlinedIcon />,
              title: <Trans>Управление доступами</Trans>,
            },
          ]
        : []),
      {
        href: '/home/settings/specialists',
        mixpanelEventName: 'open_specialists_page',
        icon: <NotificationsNoneOutlinedIcon />,
        title: <Trans>Настройка уведомлений</Trans>,
      },
    ],
    [canManageAccess],
  );

  return (
    <Box mt={8}>
      <Typography className={classes.headerTitle}>
        <Trans>Настройки</Trans>
      </Typography>

      <Box mt={6}>
        <List className={classes.listNew} disablePadding>
          {settingsLinksList.map((v, index) => (
            <RowNew key={index} link={v.href} mixpanelEventName={v.mixpanelEventName} icon={v.icon}>
              {v.title}
            </RowNew>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default Entry;
